<template>
    <div class="cart-delivery-section active">
        <h3 ref="cartDeliveryMethod">
            <span>
                <span v-if="!stepOneValid" class="step-icon">1</span>
                <span v-if="stepOneValid" class="step-icon">
                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4.79321 8.38865C4.69478 8.48766 4.56048 8.5429 4.42098 8.5429C4.28149 8.5429 4.14719 8.48766 4.04876 8.38865L1.0761 5.4155C0.767602 5.10701 0.767602 4.60676 1.0761 4.29884L1.44832 3.92652C1.75692 3.61802 2.25658 3.61802 2.56508 3.92652L4.42098 5.78252L9.4359 0.767506C9.7445 0.459008 10.2446 0.459008 10.5527 0.767506L10.9249 1.13982C11.2334 1.44832 11.2334 1.94847 10.9249 2.25649L4.79321 8.38865Z"
                            fill="white"/>
                    </svg>
                </span>
                Выберите способ доставки
            </span>

            <a class="city-marker" @click.prevent="selectCity">
                <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.85688 3.93613C5.12583 3.93613 3.72031 5.34475 3.72031 7.0727C3.72031 8.80053 5.1257 10.2122 6.85688 10.2122C8.58793 10.2122 9.99345 8.80363 9.99345 7.07567C9.99345 5.34785 8.58806 3.93613 6.85688 3.93613ZM6.85688 9.2843C5.63755 9.2843 4.64826 8.2922 4.64826 7.07567C4.64826 5.85923 5.64044 4.86705 6.85688 4.86705C8.07333 4.86705 9.06551 5.85923 9.06551 7.07567C9.06551 8.2922 8.07622 9.2843 6.85688 9.2843Z"
                        fill="#24AAFF" stroke="#24AAFF" stroke-width="0.2"/>
                    <path
                        d="M0.917532 6.42734L0.917542 6.42724C1.20162 3.46256 3.66411 1.1481 6.64363 1.04514C6.64377 1.04513 6.64392 1.04513 6.64407 1.04512L6.64752 1.14506C6.71586 1.14209 6.78716 1.14209 6.8555 1.14209C10.0911 1.14209 12.7236 3.77458 12.7296 7.00725C12.7296 7.38162 12.6939 7.75599 12.6226 8.12145L0.917532 6.42734ZM0.917532 6.42734C0.863255 7.00027 0.890234 7.57643 0.995655 8.12594L0.995822 8.12712L0.9975 8.13806C0.999002 8.14743 1.00131 8.16095 1.00466 8.17846C1.0113 8.21322 1.02202 8.26373 1.03866 8.3289C1.12926 8.73606 1.26493 9.13107 1.43674 9.49911C2.04653 10.9432 3.37857 13.1571 6.25978 15.5491L6.26009 15.5494C6.42948 15.6889 6.6421 15.7653 6.86144 15.7653C7.08079 15.7653 7.29341 15.6889 7.4628 15.5494L7.4631 15.5492C10.3415 13.16 11.6735 10.9431 12.2802 9.51094C12.455 9.13396 12.5907 8.73592 12.6813 8.33167C12.6995 8.25894 12.7118 8.19749 12.7211 8.13883L0.917532 6.42734ZM11.8006 7.98736L11.8023 7.97823C11.8637 7.65095 11.8957 7.3303 11.8957 7.01022C11.8957 4.16971 9.53575 1.87389 6.67772 1.97295C4.16074 2.06034 2.08338 4.01539 1.8416 6.5177C1.79498 7.00139 1.81828 7.49101 1.90864 7.96609L1.9104 7.97535V7.97579C1.91066 7.97702 1.91094 7.97835 1.91119 7.97971C1.91165 7.98216 1.91216 7.98521 1.91256 7.98875C1.91269 7.98938 1.91281 7.99003 1.91295 7.9907C1.91693 8.01103 1.92541 8.05427 1.94052 8.11976L1.9406 8.12012C2.0193 8.46696 2.13292 8.80195 2.28144 9.12228L2.28288 9.12539L2.28282 9.12541C2.85274 10.4738 4.10529 12.555 6.8464 14.8323C6.84901 14.8342 6.85185 14.8355 6.85466 14.8364C6.85729 14.8372 6.85895 14.8374 6.85895 14.8374C6.85895 14.8374 6.8588 14.8374 6.85847 14.8374C6.85936 14.8374 6.86077 14.8373 6.8626 14.8367C6.86417 14.8362 6.86684 14.8351 6.87046 14.8324C9.61159 12.5581 10.8612 10.4769 11.4282 9.13725L11.4293 9.13471L11.4293 9.13472C11.5811 8.80204 11.6947 8.46678 11.7734 8.12294L11.8006 7.98736ZM11.8006 7.98736V7.99067V7.98736ZM11.8011 7.98774L11.8011 7.98782L11.8011 7.98774Z"
                        fill="#24AAFF" stroke="#24AAFF" stroke-width="0.2"/>
                </svg>

                <span>{{ cityName }}</span>
            </a>
        </h3>
        <div class="cart-delivery-options">
            <div v-for="(deliveryMethod, index) in deliveryMethods" class="cart-delivery-option">
                <q-radio
                    :id="'delivery-type-' + index"
                    :class="{ 'is-invalid': hasError('delivery_method_id') }"
                    v-model="delivery_method_id"
                    :val="deliveryMethod.id"
                    :label="deliveryMethod.name"/>
            </div>
            <div v-if="hasError('delivery_method_id')" class="invalid-feedback d-block">
                {{ getError('delivery_method_id') }}
            </div>
        </div>

        <div v-if="isCourierDelivery || isPostDelivery" class="cart-delivery-address">
            <h4>Укажите адрес доставки</h4>

            <div v-if="!addressForm" class="gray-block">
                <div v-if="!addresses.length">
                    <p class="mb-2">У Вас не указано ни одного адреса для курьерской доставки. </p>
                    <p>Воспользуйтесь кнопкой "Добавить адрес" или выберите другой способ доставки.</p>
                </div>

                <div v-if="addresses.length">
                    <div v-for="(address, index) in addresses" class="cart-delivery-address-item">
                        <q-radio
                            v-if="services(delivery_method_id, address.form.region.id, address.form.city.id).length"
                            :id="'delivery-address-' + index"
                            v-model="address_id"
                            :val="address.id"
                            :label="address.address_line"/>
                        <div class="cart-delivery-notworking"
                             v-if="!services(delivery_method_id, address.form.region.id, address.form.city.id).length">
                            <span>{{ address.address_line }}</span>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 576 512" width="64"
                                     height="64">
                                    <path fill="red"
                                          d="M270.2 160h35.5c3.4 0 6.1 2.8 6 6.2l-7.5 196c-.1 3.2-2.8 5.8-6 5.8h-20.5c-3.2 0-5.9-2.5-6-5.8l-7.5-196c-.1-3.4 2.6-6.2 6-6.2zM288 388c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28zm281.5 52L329.6 24c-18.4-32-64.7-32-83.2 0L6.5 440c-18.4 31.9 4.6 72 41.6 72H528c36.8 0 60-40 41.5-72zM528 480H48c-12.3 0-20-13.3-13.9-24l240-416c6.1-10.6 21.6-10.7 27.7 0l240 416c6.2 10.6-1.5 24-13.8 24z"
                                          class=""/>
                                </svg>
                                <p>По данному адресу доставка курьером не осуществляется.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <span class="btn ml-md-auto mt-3" @click.prevent="showAddressForm">Добавить адрес</span>

                <!--                <customer-address></customer-address>-->

                <div v-if="hasError('address.house') || hasError('address.street.name')">
                    <span class="is-invalid"></span>
                    <p class="invalid-feedback">Пожалуйста, добавьте адрес доставки</p>
                </div>

                <div v-if="hasError('address.city_name')">
                    <span class="is-invalid"></span>
                    <p class="invalid-feedback">Пожалуйста, выберите адрес из списка или добавьте новый</p>
                </div>
            </div>

            <div v-if="addressForm">
                <div class="q-gutter-x-20 cart-address-first-line">
                    <div v-if="useRegion">
                        <q-select
                            clearable
                            dense
                            outlined
                            hide-selected
                            fill-input
                            use-input
                            input-debounce="0"
                            :value="address.region.id"
                            @input="setRegion"
                            option-value="id"
                            option-name="label"
                            :options="regionOptions"
                            :options-dense="true"
                            @filter="searchRegion"
                            emit-value
                            map-options
                            behavior="menu"
                            :error-message="address.errors.get('region.name')"
                            :error="address.errors.has('region.name')"
                            label="Регион">
                        </q-select>
                    </div>
                    <div>
                        <q-select
                            clearable
                            dense
                            outlined
                            hide-selected
                            fill-input
                            use-input
                            input-debounce="0"
                            :value="address.city.id"
                            @input="cityValue"
                            option-value="id"
                            option-name="label"
                            :options="cityOptions"
                            :options-dense="true"
                            @filter="searchCity"
                            emit-value
                            map-options
                            behavior="menu"
                            :error-message="address.errors.get('city.name')"
                            :error="address.errors.has('city.name')"
                            label="Город">
                            <template v-slot:no-option>
                                <q-item>
                                    <q-item-section class="text-grey">
                                        No results
                                    </q-item-section>
                                </q-item>
                            </template>
                            <template v-slot:selected>
                                {{ address.city.name }}
                            </template>
                        </q-select>
                    </div>
                    <div>
                        <span class="link" @click.prevent="useRegion = true"
                              v-if="!useRegion">Моего города нет в списке</span>
                    </div>
                </div>

                <div class="q-gutter-x-20 cart-address-second-line">
                    <div>
                        <q-select
                            clearable
                            dense
                            outlined
                            hide-selected
                            fill-input
                            use-input
                            input-debounce="0"
                            :value="address.street.id ? address.street.id : address.street.name"
                            @input-value="setStreet"
                            @clear="setStreet('')"
                            option-value="id"
                            option-name="label"
                            :options="streetOptions"
                            :options-dense="true"
                            @filter="searchStreet"
                            emit-value
                            map-options
                            hide-dropdown-icon
                            behavior="menu"
                            :error-message="address.errors.get('street.name')"
                            :error="address.errors.has('street.name')"
                            label="Улица">
                        </q-select>
                    </div>
                    <div>
                        <q-select
                            clearable
                            dense
                            outlined
                            hide-selected
                            fill-input
                            use-input
                            input-debounce="0"
                            :value="address.house"
                            @input-value="setHouse"
                            @clear="setHouse('')"
                            option-value="id"
                            option-name="label"
                            :options="houseOptions"
                            :options-dense="true"
                            @filter="searchHouse"
                            emit-value
                            map-options
                            hide-dropdown-icon
                            behavior="menu"
                            :error-message="address.errors.get('house')"
                            :error="address.errors.has('house')"
                            label="Дом">
                        </q-select>
                    </div>
                    <div>
                        <q-input
                            dense
                            outlined
                            :value="address.flat"
                            @input="setLocationFormValue('flat', $event)"
                            :error-message="address.errors.get('flat')"
                            :error="address.errors.has('flat')"
                            label="Квартира"/>
                    </div>
                    <div>
                        <q-input
                            dense
                            outlined
                            :value="address.zip"
                            @input="setLocationFormValue('zip', $event)"
                            :error-message="address.errors.get('zip')"
                            :error="address.errors.has('zip')"
                            label="Индекс"/>
                    </div>
                    <div>
                        <span class="btn" @click.prevent="addAddress">Добавить адрес</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="deliveryServices.length > 1">
            <h4>Выберите службу</h4>

            <div class="cart-delivery-options">
                <div v-for="(deliveryServiceId, index) in deliveryServices" class="cart-delivery-option">
                    <q-radio
                        :id="'delivery-service-' + index"
                        :class="{ 'is-invalid': hasError('delivery_service_id') }"
                        v-model="service_id"
                        :val="deliveryServiceId"
                        :label="deliveryServiceName(deliveryServiceId)"/>
                </div>
                <div v-if="hasError('delivery_service_id')" class="invalid-feedback d-block">
                    {{ getError('delivery_service_id') }}
                </div>
            </div>
        </div>

        <div v-if="isPickupDelivery && !pickupPoints.length" class="cart-delivery-address">
            <h4>В выбранном населённом пункте отсутствуют пункты выдачи заказа</h4>
        </div>

        <div v-if="isPickupDelivery && pickupPoints.length" class="cart-delivery-address cart-delivery-pickup-point">
            <h4>Выберите пункт самовывоза</h4>
            <div class="cart-delivery-select-map">
                <a @click.prevent="selectPickupPoints">Показать на карте</a>
            </div>
            <div class="cart-delivery-select-points">
                <q-select
                    outlined
                    use-input
                    dense
                    input-debounce="0"
                    :behavior="$q.platform.is.ios || $q.platform.is.android === true ? 'menu' : 'default'"
                    :class="{ 'is-invalid': hasError('pickup_point_id') }"
                    v-model="pickup_point_id"
                    :options="pickupPoints"
                    :option-value="opt => opt.id"
                    :option-label="opt => opt ? '<span class=\'pickuppoints-address\'>' + opt.name + ', ' + opt.address + '</span>' : ''  "
                    :options-dense="true"
                    emit-value
                    map-options
                />
                <div v-if="hasError('pickup_point_id')" class="invalid-feedback">
                    {{ getError('pickup_point_id') }}
                </div>
            </div>
        </div>

        <div v-if="isStoreDelivery && !stores.length" class="cart-delivery-address">
            <h4>В выбранном населённом пункте отсутствуют пункты выдачи заказа</h4>
        </div>

        <div v-if="isStoreDelivery && stores.length" class="cart-delivery-address cart-delivery-pickup-point">
            <h4>Выберите магазин</h4>
            <div class="cart-delivery-select-map">
                <a @click.prevent="selectPickupPoints">Показать на карте</a>
            </div>
            <div class="cart-delivery-select-points">
                <q-select
                    outlined
                    use-input
                    dense
                    input-debounce="0"
                    :behavior="$q.platform.is.ios || $q.platform.is.android === true ? 'menu' : 'default'"
                    :class="{ 'is-invalid': hasError('pickup_point_id') }"
                    v-model="pickup_point_id"
                    :options="stores"
                    :option-value="opt => opt.id"
                    :option-label="opt => opt ? '<span class=\'pickuppoints-address\'>' + opt.name + ', ' + opt.address + '</span>' : ''  "
                    :options-dense="true"
                    emit-value
                    map-options
                />
                <div v-if="hasError('pickup_point_id')" class="invalid-feedback">
                    {{ getError('pickup_point_id') }}
                </div>
            </div>
        </div>

        <ul class="cart-delivery-features">
            <li v-if="isCourierDelivery" class="list-delivery">Служба доставки: КС</li>
            <li v-if="isPostDelivery" class="list-delivery">Служба доставки: Почта России</li>
            <li v-if="deliveryDays" class="list-time">{{ `Доставка ${deliveryDays}` }}</li>
            <li v-if="maxProductCount" class="list-warning">{{ `Заказ до ${maxProductCount} пар` }}</li>
        </ul>
    </div>
</template>

<script>
import location from './../../../mixins/location';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

export default {
    mixins: [
        location,
    ],
    watch: {
        delivery_method_id(newValue, oldValue) {
            this.methodChanged(newValue, oldValue);
        },
        address_id(newValue, oldValue) {
            this.$store.commit('cart/setFormValue', {
                key: 'payment_type_id',
                value: ''
            });
        },
        location(newValue, oldValue) {
            if (this.isPickupDelivery || this.isPostDelivery) {
                this.$store.dispatch('cart/setLocation', this.location);
            }
        },
        pickupPoints(newValue, oldValue) {
            this.pickup_point_id = '';
        },
        'errors'(errors) {
            if (_.intersection(_.keys(errors), ['items_count']).length) {
                this.$nextTick(() => {
                    document.getElementById('cart').scrollIntoView({block: 'start', behavior: 'smooth'});
                });
            } else if (_.intersection(_.keys(errors), ['address.house', 'address.street.name', 'delivery_method_id']).length) {
                this.$nextTick(() => {
                    this.$refs.cartDeliveryMethod.scrollIntoView({block: 'start', behavior: 'smooth'});
                });
            }
        },
    },
    methods: {
        ...mapActions('customer', [
            'addAddress',
            'newAddress'
        ]),
        ...mapMutations('customer', [
            'setAddressFormValue',
            // 'showAddressForm',
        ]),
        cityValue(val) {
            let _this = this;
            this.setCity(val);
            this.address.put('/location')
                .then(response => {
                    if (response.redirect) {
                        window.location.href = window.location.protocol + '//' + response.redirect + window.location.href.replace(window.location.origin, "");
                    }
                });
        },
        selectCity() {
            this.$store.commit('geo/showModal');
        },
        getLocationForm() {
            return this.address;
        },
        showAddressForm() {
            this.newAddress();

            this.$nextTick(() => {
                this.initLocationOptions();
            });

            this.addressForm = true;
        },
        methodChanged(newValue, oldValue) {
            this.$store.commit('cart/setFormValue', {
                key: 'payment_type_id',
                value: ''
            });
            if (this.isPickupDelivery || this.isStoreDelivery) {
                this.$store.commit('cart/setFormValue', {
                    key: 'address_id',
                    value: ''
                });

                this.$store.dispatch('cart/setLocation', this.location);
            } else if (oldValue === 2) {
                this.$store.dispatch('cart/setAddress', null);
            }
        },
        selectPickupPoints() {
            this.$root.showPickupPoints(true);
        }
    },
    computed: {
        ...mapState('cart', [
            'form',
            'errors',
        ]),
        ...mapState('geo', [
            'location',
        ]),
        ...mapGetters('asset', [
            'deliveryServiceName',
        ]),
        ...mapState('customer', [
            'address',
            'addresses',
        ]),
        ...mapGetters('geo', [
            'deliveryLocation',
            'cityName',
        ]),
        ...mapGetters('customer', [
            'getAddressById',
        ]),
        ...mapGetters('cart', [
            'isCourierDelivery',
            'isPickupDelivery',
            'isPostDelivery',
            'isStoreDelivery',
            'stepOneValid',
            'hasError',
            'getError',
        ]),
        ...mapGetters('delivery', [
            'services',
            'servicePickupPoints'
        ]),
        ...mapState('delivery', [
            'deliveries',
            'stores',
            'storesCount'
        ]),
        deliveryMethods() {
            return this.$store.getters['asset/deliveryMethods']
                .filter(method => this.deliveries.map(delivery => delivery.delivery_method_id).includes(method.id));
        },
        deliveryServices() {
            let _this = this;

            let services = _this.$store.state.cart.form.address.region.id
            && _this.$store.state.cart.form.address.city.id
            && _this.$store.state.cart.form.delivery_method_id
                ? _this.services(
                    _this.$store.state.cart.form.delivery_method_id,
                    _this.$store.state.cart.form.address.region.id,
                    _this.$store.state.cart.form.address.city.id
                )
                : [];

            if (services.length && (services.indexOf(_this.service_id) === -1)) {
                _this.service_id = services[0];
            }

            return services;
        },
        pickupPoints() {
            return this.isPickupDelivery && this.$store.state.cart.form.service_id
                ? this.servicePickupPoints(this.$store.state.cart.form.service_id)
                : [];
        },
        delivery_method_id: {
            get() {
                return this.$store.state.cart.form.delivery_method_id;
            },
            set(value) {
                this.$store.commit('cart/setFormValue', {
                    key: 'delivery_method_id',
                    value: value
                });

                if (this.isStoreDelivery) {
                    this.service_id = 1;
                }
            }
        },
        address_id: {
            get() {
                return this.$store.state.cart.form.address_id;
            },
            set(value) {
                this.$store.dispatch('cart/setAddress', value);
            }
        },
        service_id: {
            get() {
                return this.$store.state.cart.form.service_id;
            },
            set(value) {
                this.$store.commit('cart/setFormValue', {
                    key: 'service_id',
                    value: value
                });
            }
        },
        pickup_point_id: {
            get() {
                return this.$store.state.cart.form.pickup_point_id;
            },
            set(value) {
                this.$store.commit('cart/setFormValue', {
                    key: 'pickup_point_id',
                    value: value
                });
            }
        },
        delivery() {
            return _.find(this.deliveries, d => d.delivery_method_id === this.delivery_method_id && d.city_id === this.location.city.id);
        },
        deliveryDays() {
            return this.delivery ?
                this.delivery.min_delivery_time + '-' + this.delivery.max_delivery_time + (this.delivery.max_delivery_time > 4 ? ' дней' : ' дня')
                : '';
        },
        maxProductCount() {
            return this.delivery ?
                this.delivery.max_products_count + (this.delivery.max_products_count > 4 ? '-и' : '-x')
                : '';
        },
        addressForm: {
            get() {
                return this.$store.state.customer.addressModal !== false;
            },

            set(value) {
                value
                    ? this.$store.commit('customer/showAddressForm', 0)
                    : this.$store.commit('customer/hideAddressForm');
            }
        },
    }
}
</script>
